import { api } from './api'

export const fetchShortLink = (query) => api.get('/short-link', query)
export const createShortLink = (url) => api.post('/short-link', url)
